app.controller('Inbox_CreateOrEditPortletController',
[
    '$scope', '$uibModalInstance', 'createOrEditModalService', 'inboxPluginConfigurationService', 'data', 'inboxService',
    function ($scope, $uibModalInstance, createOrEditModalService, inboxPluginConfigurationService, data, inboxService) {


        var init = function () {

            inboxService.getInboxes()
                .then(function(result) {
                    $scope.inboxes = {
                        filter: "contains",
                        autoBind: false,
                        dataSource: result.data,
                        dataTextField: "Title",
                        dataValueField: "Id"
                    };
                }).catch(angular.noop);
        }();

      
        $scope.model = createOrEditModalService.getModel("Inbox", data);
        $scope.configurationModel = inboxPluginConfigurationService.getConfigurationModel($scope.model.Properties);

        $scope.panelBarOptions = {
            expandMode: "single",
            select: $scope.expandCollapse
        };

        $scope.validateDataSource = function () {
            if ($scope.configurationModel.inboxId === null || $scope.configurationModel.inboxId === "") {
                $scope.portletConfigurationForm.inboxList = {$error: {required: true}};
                return false;
            }
            else {
                $scope.portletConfigurationForm.inboxList = {$error: {required: false}};
                return true;
            }
        };

        $scope.ok = function() {
            inboxPluginConfigurationService.saveProperties($scope.model.Properties,
                $scope.configurationModel,
                data.operation);
            $uibModalInstance.close($scope.model);
        };

        $scope.cancel = function() {
            $uibModalInstance.dismiss('cancel');        
        };
    }
]);